import React from 'react';
import { Icon, IconProps } from './Icon';

export const SlidersHorizontalIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      strokeWidth={0.5}
      viewBox="0 0 20 20"
      height="20"
      width="20"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.43758 6.66764H2.49923C2.03899 6.66764 1.66589 6.29454 1.66589 5.83431C1.66589 5.37408 2.03899 5.00098 2.49923 5.00098H3.43758C3.80761 3.56328 5.11269 2.50098 6.66589 2.50098C8.21909 2.50098 9.52414 3.56328 9.89423 5.00098H17.4992C17.9595 5.00098 18.3326 5.37408 18.3326 5.83431C18.3326 6.29454 17.9595 6.66764 17.4992 6.66764H9.89423C9.52414 8.10533 8.21909 9.16764 6.66589 9.16764C5.11269 9.16764 3.80761 8.10533 3.43758 6.66764ZM4.99923 5.83431C4.99923 4.91383 5.74542 4.16764 6.66589 4.16764C7.58637 4.16764 8.33256 4.91383 8.33256 5.83431C8.33256 6.75478 7.58637 7.50098 6.66589 7.50098C5.74542 7.50098 4.99923 6.75478 4.99923 5.83431Z"
        fill="#808080"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1042 15.001H2.49923C2.03899 15.001 1.66589 14.6279 1.66589 14.1676C1.66589 13.7074 2.03899 13.3343 2.49923 13.3343H10.1042C10.4743 11.8966 11.7794 10.8343 13.3326 10.8343C14.8857 10.8343 16.1908 11.8966 16.5609 13.3343H17.4992C17.9595 13.3343 18.3326 13.7074 18.3326 14.1676C18.3326 14.6279 17.9595 15.001 17.4992 15.001H16.5609C16.1908 16.4386 14.8857 17.501 13.3326 17.501C11.7794 17.501 10.4743 16.4386 10.1042 15.001ZM11.6659 14.1676C11.6659 13.2471 12.4121 12.501 13.3326 12.501C14.2531 12.501 14.9992 13.2471 14.9992 14.1676C14.9992 15.0881 14.2531 15.8343 13.3326 15.8343C12.4121 15.8343 11.6659 15.0881 11.6659 14.1676Z"
        fill="#808080"
      />
    </Icon>
  );
};
